import { BoardValue } from '../../jscaip/AI/BoardValue';
import { Coord } from '../../jscaip/Coord';
import { Ordinal } from '../../jscaip/Ordinal';
import { Player } from '../../jscaip/Player';
import { PlayerNumberMap } from '../../jscaip/PlayerMap';
import { EpaminondasHeuristic } from './EpaminondasHeuristic';
export class EpaminondasPieceThenRowDominationThenAlignmentThenRowPresenceHeuristic extends EpaminondasHeuristic {
    getBoardValue(node, _config) {
        const width = node.gameState.getWidth();
        const height = node.gameState.getHeight();
        let pieces = 0;
        let alignement = 0;
        let rowDomination = 0;
        let presence = 0;
        for (let y = 0; y < height; y++) {
            let row = 0;
            const wasPresent = PlayerNumberMap.of(0, 0);
            for (let x = 0; x < width; x++) {
                const coord = new Coord(x, y);
                const player = node.gameState.getPieceAt(coord);
                if (player.isPlayer()) {
                    const mod = player.getScoreModifier();
                    pieces += mod;
                    wasPresent.put(player, mod);
                    row += mod;
                    for (const dir of [Ordinal.UP_LEFT, Ordinal.UP, Ordinal.UP_RIGHT]) {
                        let neighbor = coord.getNext(dir, 1);
                        while (node.gameState.hasPieceAt(neighbor, player)) {
                            alignement += mod;
                            neighbor = neighbor.getNext(dir, 1);
                        }
                    }
                }
            }
            if (row !== 0) {
                rowDomination += Math.abs(row) / row;
            }
            presence += wasPresent.get(Player.ZERO) + wasPresent.get(Player.ONE);
        }
        return BoardValue.multiMetric([
            pieces,
            rowDomination,
            alignement,
            presence,
        ]);
    }
}
